import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Message} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import {isNil} from 'ramda';
import styled from 'styled-components';
import {GreenButton, DefaultButton} from '../../components/Button/ButtonMix';
import {BlueContainer} from '../../components/Container/ContainerMix';
import {FormInputLogin} from '../../components/Form/FormInputMix';
import {authenticate} from '../../api';
import {saveUser} from '../../util/Session';

const EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
const MINIMUM_PASSWORD_LENGTH = 6;

const Heading = styled.div`
  text-align: center;
  padding: calc(10vh) 0 40px;
  & > h1 {
    color: #ffffff;
  }
  & > p {
    color: #ffffff;
  }
`;

const Buttons = styled.div`
  margin-top: 1rem;
`;

const Logo = styled.img`
  max-width: 500px;
`;

const Links = styled.div`
  padding: 10px;
  text-align: center;
  width: 100%;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      email: null,
      emailError: null,
      password: null,
      passwordError: null
    };
  }

  handleChange = (e, {name, value}) => this.setState({[name]: value});

  handleSubmit = () => {
    const {router} = this.props;
    const {email, password} = this.state;

    // validate email address
    const isEmailValid = email && email.match(EMAIL_REGEX);
    this.setState({emailError: !isEmailValid ? 'Invalid email address' : null});

    // validate password
    const isPasswordValid = password && password.length >= MINIMUM_PASSWORD_LENGTH;
    this.setState({passwordError: !isPasswordValid ? `Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters long` : null});

    if (!isEmailValid || !isPasswordValid) return;

    return authenticate(email, password)
      .then(response => {
        const {data: user} = response;
        // save user and redirect to logged in part of app
        saveUser(user);
        router.push('/dashboard');
        return null;
      })
      .catch(e => {
        e.response ? this.setState({error: e.response.data.error}) : this.setState({error: e.message});
      });
  };

  render() {
    const {error, emailError, passwordError} = this.state;
    const {router} = this.props;
    const isError = !isNil(error) || !isNil(emailError) || !isNil(passwordError);
    return (
      <BlueContainer>
        <Heading>
          <Logo src="images/logotype-white.svg" alt="Logo" />
          <p>Welcome to the BodyBank App.  Let's get started.</p>
        </Heading>
        <Form error={isError} onSubmit={this.handleSubmit}>
          <FormInputLogin label="Email" type="text" name="email" onChange={this.handleChange} required autoCapitalize="none"/>
          <FormInputLogin label="Password" type="password" name="password" onChange={this.handleChange} required/>
          <Message error header="Error" content={[error, emailError, passwordError].filter(e => !isNil(e)).join(', ')}/>
          <GreenButton>Login</GreenButton>
        </Form>
        <Buttons>
          <DefaultButton onClick={() => router.push('/sign-up')}>Sign up</DefaultButton>
        </Buttons>
        <Links>
          <a href="/forgot-password">Forgot password</a>
        </Links>
      </BlueContainer>
    );
  }
}

Login.propTypes = {
  router: PropTypes.object.isRequired
};

export default withRouter(Login);
export {Login as PureLogin};



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js